import { render, staticRenderFns } from "./WaterLeakageCauseLocalizedPlumberIntervenedQuestion.vue?vue&type=template&id=563518a4"
import script from "./WaterLeakageCauseLocalizedPlumberIntervenedQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseLocalizedPlumberIntervenedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports